import { Component, OnInit, Inject, OnDestroy, inject } from '@angular/core';
import { UpdateService } from './services/update.service';
import { DbInitService } from './services/core/db-init.service';
import { PerformanceMonitorService } from './services/core/performance-monitor.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterOutlet } from '@angular/router';
import { MsalModule, MsalService } from '@azure/msal-angular';

import { CommonModule } from '@angular/common';
import { PhotoAffichageService } from '@services/core/photo-affichage.service';
import { SentinelleService } from '@services/core/sentinelle.service';
import { RecalageEcranService } from '@services/core/recalage-ecran.service';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [
		CommonModule,
		MsalModule,
		RouterOutlet,
		MatToolbarModule,
		MatButtonModule,
		MatMenuModule
	],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
	title = 'Angular 18 Sample - MSAL Angular v3';
	isIframe = false;
	loginDisplay = false;

	private photoAffichageService = inject(PhotoAffichageService);
	private sentinelle = inject(SentinelleService);
	private recalageEcran = inject(RecalageEcranService);

	constructor(
		private readonly updateService: UpdateService,
		private readonly dbInitService: DbInitService,
		private readonly performanceMonitor: PerformanceMonitorService,
		private readonly msal: MsalService,
	) { }

	ngOnInit(): void {
		// Initialiser le monitoring de performance
		this.performanceMonitor.init();

		// Initialiser les bases de données et migrations
		this.dbInitService.initialize().catch(err => {
			console.error('❌ Erreur initialisation DB:', err);
		});

		this.updateService.init();
		// Loaders / « photo indisponible » sur toutes les photos, y compris en HTML injecté.
		this.photoAffichageService.init();
		// Détection des arrêts brutaux (page blanche par manque de mémoire, iPad).
		this.sentinelle.demarrer();
		// Touchers décalés vers le bas sur iOS après le clavier ou l'appareil photo (ATLAS-252).
		this.recalageEcran.demarrer();
		try {
			const acct = this.msal.instance.getActiveAccount() || this.msal.instance.getAllAccounts()[0];
			if (acct) {
				const claims: any = acct.idTokenClaims || {};
				const username = claims?.preferred_username || acct.username || claims?.email || claims?.upn;
				const name = claims?.name || claims?.displayName || undefined;
				const email = claims?.email || (typeof username === 'string' && username.includes('@') ? username : undefined);
				localStorage.setItem('sentryUser', JSON.stringify({ username, name, email }));
			}
		} catch {}
	}
}
